import { useNavigate } from "react-router-dom"
import useListRole from "./useListRole"
import { useEffect, useState } from "react"
import DeleteModal from "../../../../components/modal/DeleteModal"
import { BsPencilSquare, BsFillTrashFill } from "react-icons/bs"
import Loading from "../../../../components/loading/Loading"

const ListRole = ({ hideCreateButton = false }) => {
    const navigate = useNavigate()
    const {payload, getRoles, deleteRole, loadingPagestate} = useListRole()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState()
    const [userName, setName] = useState()

    useEffect(() => {
        getRoles()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return(
        <div>
            <Loading state={loadingPagestate}/>
            {!hideCreateButton && (
                <div className="d-flex">
                    <button className="btn btn-primary add-button" onClick={() => navigate('/user-management/role-form')}>
                        Create Role
                    </button>
                </div>
            )}
            <div className="table-responsive">
                <table className="table align-items-center">
                    <thead>
                        <tr>
                            <th scope="col">Role</th>
                            <th scope="col">Description</th>
                            <th scope="col" style={{width: '5%'}}></th>
                            <th scope="col" style={{width: '5%'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            payload.map((data) => (
                                <tr key={data.ID}>
                                    <td>{data.Name}</td>
                                    <td>{data.Description}</td>
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            onClick={() => navigate(`/user-management/role-form/${data.ID}`)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #02B4CC',
                                                backgroundColor: 'transparent',
                                                color: '#02B4CC',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#02B4CC';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#02B4CC';
                                            }}
                                        >
                                            <BsPencilSquare/>
                                            Edit
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            onClick={() =>{
                                                handleShow()        
                                                setDeleteID(data.ID)
                                                setName(data.Name)
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #dc3545',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#dc3545';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#dc3545';
                                            }}
                                        >
                                            <BsFillTrashFill/>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <DeleteModal 
                show={show} 
                handleClose={handleClose} 
                handleOk={async () => {
                    await deleteRole(deleteID, () => getRoles())
                    handleClose()
                }} 
                title={userName}
            />
        </div>
    )
}

export default ListRole